import React from 'react';
import PropTypes from 'prop-types';
import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import Notification from '../components/HomePageNew/NotificationNew';

const NotificationNew = ({ ...props }) => {
  return (
    <HeaderFooterLayout >
      <Notification {...props} />
    </HeaderFooterLayout>
  );
};

// NotificationNew.propTypes = {
//   loadClubs: PropTypes.func.isRequired,
// };

export default NotificationNew;
